var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_32387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8531 7.51122L11.3531 3.10306C11.1578 2.91173 10.8412 2.91173 10.6462 3.10306C10.4513 3.29439 10.4509 3.60449 10.6462 3.79551L14.2937 7.36735H5.5C5.225 7.36735 5 7.58776 5 7.85714C5 8.12653 5.22363 8.34694 5.5 8.34694H14.2937L10.6469 11.9194C10.4516 12.1107 10.4516 12.4208 10.6469 12.6118C10.8422 12.8029 11.1588 12.8032 11.3538 12.6118L15.8538 8.20367C15.95 8.10816 16 7.98265 16 7.85714C16 7.73163 15.95 7.60612 15.8531 7.51122ZM5.5 13.7347H2.5C1.67281 13.7347 1 13.0765 1 12.2653V3.44898C1 2.63867 1.67281 1.97959 2.5 1.97959H5.5C5.775 1.97959 6 1.76041 6 1.4898C6 1.21918 5.775 1 5.5 1H2.5C1.12125 1 0 2.09837 0 3.44898V12.2653C0 13.6153 1.12125 14.7143 2.5 14.7143H5.5C5.775 14.7143 6 14.4939 6 14.2245C6 13.9551 5.775 13.7347 5.5 13.7347Z",
    fill: "#149CE0",
    stroke: "#149CE0",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_32387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.7be16de4c8755341e19e9d84f571b6d9.svg";
export { ForwardRef as ReactComponent };